import moment from 'moment';
import React, { Component } from 'react';
import { Table as BootstrapTable, Col, Row } from 'react-bootstrap';

import { IS_VALID } from 'utils';

export default class View extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoadingRelation: false,
			cardType: [],
			specificUser: [],
			blacklistedUser: [],
		};

		this.getRelation = this.getRelation.bind(this);
	}

	getRelation() {
		let {
			selectedData,

			getRelation,
		} = this.props;

		if (IS_VALID(selectedData)) {
			this.setState({ isLoadingRelation: true });

			getRelation()
				.then(([cardType, specificUser, blacklistedUser]) => {
					let cardTypeArray = cardType.map((item) => item.get('name'));

					let specificUserArray = specificUser.map(
						(item) =>
							`${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
								IS_VALID(item.get('name')) ? item.get('name') : ''
							}`
					);

					let blacklistedUserArray = blacklistedUser.map(
						(item) =>
							`${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
								IS_VALID(item.get('name')) ? item.get('name') : ''
							}`
					);

					this.setState({
						isLoadingRelation: false,
						cardType: cardTypeArray,
						specificUser: specificUserArray,
						blacklistedUser: blacklistedUserArray,
					});
				})
				.catch((err) => {
					console.log('err', err);
					this.setState({ isLoadingRelation: false });
				});
		}
	}

	render() {
		let { isLoadingRelation, cardType, specificUser, blacklistedUser } = this.state;

		let {
			selectedData,

			visibilityOptions,
		} = this.props;

		const GET_VALUE = (key) => {
			if (IS_VALID(selectedData)) {
				let value = '';

				if (key === 'createdAt' || key === 'updatedAt') {
					value = moment(selectedData.get(key)).format('MMM DD, YYYY hh:mm A');
				} else if (key === 'campaignStartDate' || key === 'campaignEndDate') {
					if (IS_VALID(selectedData.get(key))) {
						value = moment(selectedData.get(key)).format('MMM DD, YYYY hh:mm A');
					}
				} else if (key === 'createdBy' || key === 'updatedBy') {
					if (IS_VALID(selectedData.get(key))) {
						value = selectedData.get(key).get('name') || '';
					}
				} else if (key === 'urlType') {
					if (selectedData.get('isEasyPromos')) {
						value = 'EasyPromos';
					} else if (selectedData.get('isEpicMillions')) {
						value = 'Epic Millions';
					}
				} else if (key === 'visibilityType') {
					if (selectedData.get(key)) {
						for (const item of visibilityOptions) {
							if (item.value === selectedData.get(key)) {
								value = item;
								break;
							}
						}
					}
				} else if (IS_VALID(selectedData)) {
					value = selectedData.get(key);
				}

				return value;
			} else {
				return '';
			}
		};

		let image = GET_VALUE('image');
		let visibilityType = GET_VALUE('visibilityType');
		let visibilityTimeConfig = GET_VALUE('visibilityTimeConfig');

		return (
			<BootstrapTable bordered responsive>
				<tbody>
					<tr>
						<td>
							<b>Image</b>
						</td>
						<td>
							{image !== '' ? (
								<div
									style={{
										maxWidth: '200px',
										maxHeight: '200px',
										height: '200px',
										width: '200px',
										display: 'table-cell',
										verticalAlign: 'middle',
									}}
								>
									<img src={image.url()} width="100%" />
								</div>
							) : (
								''
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Browser</b>
						</td>
						<td>{GET_VALUE('browser')}</td>
					</tr>
					<tr>
						<td>
							<b>URL</b>
						</td>
						<td>{GET_VALUE('url')}</td>
					</tr>
					<tr>
						<td>
							<b>Sort</b>
						</td>
						<td>{GET_VALUE('sort')}</td>
					</tr>
					<tr>
						<td>
							<b>URL Type</b>
						</td>
						<td>{GET_VALUE('urlType')}</td>
					</tr>
					<tr>
						<td>
							<b>Promo ID</b>
						</td>
						<td>{GET_VALUE('promoId')}</td>
					</tr>
					<tr>
						<td>
							<b>Visibility</b>
						</td>
						<td>{visibilityType && visibilityType.label}</td>
					</tr>
					<tr>
						<td>
							<b>Visibility Time</b>
						</td>
						<td>
							{visibilityType &&
								visibilityType.value === 'TR' &&
								visibilityTimeConfig && (
									<Row>
										<Col md={6}>
											<p>
												Start
												<br />
												{visibilityTimeConfig && visibilityTimeConfig.start}
											</p>
										</Col>
										<Col md={6}>
											<p>
												End
												<br />
												{visibilityTimeConfig && visibilityTimeConfig.end}
											</p>
										</Col>
									</Row>
								)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Campaign Start Date</b>
						</td>
						<td>{GET_VALUE('campaignStartDate')}</td>
					</tr>
					<tr>
						<td>
							<b>Campaign End Date</b>
						</td>
						<td>{GET_VALUE('campaignEndDate')}</td>
					</tr>
					<tr>
						<td>
							<b>Card Type</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								<div
									style={{
										maxHeight: '200px',
										overflowY: 'scroll',
									}}
								>
									{cardType.join(', ')}
								</div>
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Device Type</b>
						</td>
						<td>{GET_VALUE('deviceType')}</td>
					</tr>
					<tr>
						<td>
							<b>Specific User</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								<div
									style={{
										maxHeight: '200px',
										overflowY: 'scroll',
									}}
								>
									{specificUser.join(', ')}
								</div>
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Excluded User</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								<div
									style={{
										maxHeight: '200px',
										overflowY: 'scroll',
									}}
								>
									{blacklistedUser.join(', ')}
								</div>
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Created At</b>
						</td>
						<td>{GET_VALUE('createdAt')}</td>
					</tr>
					<tr>
						<td>
							<b>Updated At</b>
						</td>
						<td>{GET_VALUE('updatedAt')}</td>
					</tr>
					<tr>
						<td>
							<b>Created By</b>
						</td>
						<td>{GET_VALUE('createdBy')}</td>
					</tr>
					<tr>
						<td>
							<b>Updated By</b>
						</td>
						<td>{GET_VALUE('updatedBy')}</td>
					</tr>
				</tbody>
			</BootstrapTable>
		);
	}

	componentDidMount() {
		this.getRelation();
	}
}



// WEBPACK FOOTER //
// ./components/MkioskBanner/FormContainer/View.js